import React, { useState } from 'react';
import '../styles/DisclaimerPopup.css';

const DisclaimerPopup = ({ onClose }) => {
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
    }, 500); // Match this to the CSS animation duration
  };

  return (
    <div className={`disclaimer-overlay ${isClosing ? 'closing' : ''}`}>
      <div className="disclaimer-popup">
        <div className="disclaimer-header">
          <div className="disclaimer-logo">
            <div className="logo-cube"></div>
            <h2>Blender Portfolio</h2>
          </div>
          <button className="close-button" onClick={handleClose} aria-label="Close">
            &times;
          </button>
        </div>
        
        <div className="disclaimer-content">
          <h3>Welcome to Bishop Pixel Studios</h3>

          <p>
            This portfolio contains artwork that may include artistic nudity, fantasy themes, or stylized violence. 
            By continuing, you acknowledge that you are of legal age to view such content in your jurisdiction.
          </p>
          
          <p>
            Thank you for visiting, enjoy.
          </p>
        </div>
        
        <div className="disclaimer-footer">
          <button className="agree-button" onClick={handleClose}>
            I Understand & Agree
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerPopup;